// extracted by mini-css-extract-plugin
export var addButton = "_4i-d";
export var bullets = "_4i-e";
export var compact = "_4i-2";
export var container = "_4i-j";
export var extendedWarrantyModal = "_4i-f";
export var learn = "_4i-l";
export var learnMore = "_4i-g";
export var offeringOption = "_4i-3";
export var offeringPrice = "_4i-8";
export var offeringSubtitle = "_4i-7";
export var offeringTitle = "_4i-6";
export var offeringsContainer = "_4i-0";
export var pdpTilesBackground = "_4i-n";
export var plan = "_4i-m";
export var regular = "_4i-1";
export var remove = "_4i-k";
export var seeDetailsIcon = "_4i-i";
export var seeDetailsLink = "_4i-h";
export var selectedOption = "_4i-4";
export var shieldIcon = "_4i-b";
export var shieldIconCompact = "_4i-c";
export var subtitle = "_4i-a";
export var title = "_4i-9";
export var unselectedOption = "_4i-5";